module.exports = {
          srcSet: __webpack_public_path__ + "images/1989-5e7f9f2da9132439e5a6cf5e5133bee1-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1989-3e1da157763926f78c8f178855a92de6-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1989-5e7f9f2da9132439e5a6cf5e5133bee1-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1989-3e1da157763926f78c8f178855a92de6-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1989-5e7f9f2da9132439e5a6cf5e5133bee1-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1989-5e7f9f2da9132439e5a6cf5e5133bee1-320.jpg"},
          
          width: 320,
          height: 251
        }